import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiObjectData } from '../models/api-object-data';
import { Country } from '../models/country';
import { BaseService } from './base.service';

@Injectable({
    providedIn: 'root'
})
export class DashboardService {

    controller = 'dashboard';

    constructor(private base: BaseService) { }

    gets(): Observable<ApiObjectData> {
        return this.base.gets(this.controller);
    }
}
